import { AxiosResponse } from 'axios';
import { atom } from 'jotai';
import { queryClientAtom } from 'jotai-tanstack-query';

import appConfig from 'app-config';

import { GEM_PRODUCT_QUERY_KEYS } from 'src/hooks/useGemProductQuery';
import { getPurchasableSubscriptionProductsAtom } from 'src/stores/payments/atoms';
import { GemProductsResponse } from 'src/types/Payments';
import { VipRatingDetails, VipUserRating } from 'src/types/VIP';
import { getAtomWithStorage } from 'src/utils/localStorageUtils';

import { getVipRating, getVipRatingDetails } from './apis';

export const vipRatingAtom = getAtomWithStorage<VipUserRating | null>('VipUserRating', null);
export const getVipRatingAtom = atom(null, async (_, set) => {
  if (appConfig.features.vip.enabled) {
    const res = await getVipRating();
    set(vipRatingAtom, res.data);
  }
});

export const currentRatingIndexAtom = atom<number>(0);
export const selectedRatingIndexAtom = atom<number>(0);
export const pgEnableAtom = atom<boolean>(false);
export const vipRatingDetailsAtom = atom<VipRatingDetails | void>(undefined);
export const getVipRatingDetailsAtom = atom(null, async (get, set) => {
  const queryClient = get(queryClientAtom);
  const [result] = await Promise.allSettled([
    getVipRatingDetails(),
    queryClient.refetchQueries({ queryKey: GEM_PRODUCT_QUERY_KEYS.getGemProducts() }),
    set(getPurchasableSubscriptionProductsAtom),
  ]);
  if (result.status !== 'fulfilled') {
    if (window.AzarJs) {
      alert('Sorry. Please retry');
    }
    return;
  }
  const res = result.value;
  const gemProductsData = queryClient.getQueryData<AxiosResponse<GemProductsResponse>>(
    GEM_PRODUCT_QUERY_KEYS.getGemProducts()
  );
  const currentIndex = res.data.ratings.findIndex(
    ({ rating }) => rating === res.data.userRating.currentRating
  );
  set(currentRatingIndexAtom, currentIndex);
  set(selectedRatingIndexAtom, (currentIndex || res.data.ratings.length - 1) - 1);
  if (gemProductsData?.data) {
    set(pgEnableAtom, !!gemProductsData.data.paymentMethod);
  }
  set(vipRatingDetailsAtom, res.data);
});
